export default __webpack_public_path__ + "static/media/DNo.22-1.c2291a4d.jpg";